import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import BgImageContent from '../../../layout/BgImageContent';
import backgroundImage from '../../../assets/images/admin-bg.png';
import ResetPasswordForm from '../../../forms/resetPassword';
const ResetPasswordPage = () => {
    const { t } = useTranslation();
    return (_jsx(AdminPageLayout, { children: _jsx("div", { className: 'page-content-wrapper reset-password-page', children: _jsx(BgImageContent, { backgroundColor: "#01978833", imageSrc: backgroundImage, imagePosition: 'bottom', title: t('admin.create_new_password'), color: "#000", children: _jsx(ResetPasswordForm, {}) }) }) }));
};
export default ResetPasswordPage;
